import { Id } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { useRegion } from "../../../region/RegionProvider";
import { PaymentProviderOptionResource } from "../../types/paymentProviderOptionResource";
import { RegistrationFormResource } from "../../types/registrationForm";
import { registrationFormService } from "./registrationFormService";

const registrationFormDetailsFetcher = (formId: Id, token: string | null, regionId: Id | null) => () =>
	registrationFormService.show(formId, token, regionId).then((r) => r.data.data);

export const useRegistrationFormDetailsQuery = (formId: Id, token: string | null) => {
	const { regionId } = useRegion();
	const { data, isLoading, isError } = useQuery({
		queryKey: registrationFormService.keys
			.details(formId)
			.concat(token || "")
			.concat(regionId ? `${regionId}` : ""),
		queryFn: registrationFormDetailsFetcher(formId, token, regionId),
	});

	return {
		data,
		isLoading,
		isError,
	};
};

const registrationFormPreviewDetailsFetcher = (formId: Id, regionId: Id | null) => () =>
	registrationFormService.previewShow(formId, regionId).then((r) => r.data.data);

export const useRegistrationFormPreviewDetailsQuery = (formId: Id) => {
	const { regionId } = useRegion();
	const { data, isLoading, isError } = useQuery({
		queryKey: registrationFormService.keys.previewDetails(formId).concat(regionId ? `${regionId}` : ""),
		queryFn: registrationFormPreviewDetailsFetcher(formId, regionId),
	});

	return {
		data: data as any as RegistrationFormResource,
		isLoading,
		isError,
	};
};

const initialPaymentProviders: PaymentProviderOptionResource[] = [];
const registrationFormPaymentProvidersFetcher = (formId: Id) => () =>
	registrationFormService.getPaymentProviders(formId).then((r) => r.data.data);
export const useRegistrationFormPaymentProvidersQuery = (formId: Id) => {
	const { data, isLoading } = useQuery({
		queryKey: registrationFormService.keys.paymentProviders(formId),
		queryFn: registrationFormPaymentProvidersFetcher(formId),
	});

	return {
		data: data || initialPaymentProviders,
		isLoading,
	};
};

export const useLandingPageConsents = (registrationFormId: Id, regionId: Id | null) => {
	const { data: landingConsents = [], isLoading } = useQuery({
		queryKey: [...registrationFormService.keys.consentsForLandingPage(registrationFormId), regionId],
		queryFn: () =>
			registrationFormService.consentsForLandingPage(registrationFormId, regionId).then((x) => x.data.data),
	});

	return {
		landingConsents,
		isLoading,
	};
};
